<template>
  <div class="pass-steps-container">
    <section class="pass-steps-intro-container m-auto">
      <h4>To continue, kindly follow the steps below:</h4>
      <p>
        If you have any clarifications or questions, please click
        <a :href="passQuestion">here.</a>
      </p>
    </section>
    <!-- do steps here -->
    <section class="pass-steps">
      <!--
        THIS IS WHERE THE MAGIC HAPPENS!
        This creates each step's layout and functionality
        IMPORTANT: Set all property values.
      -->
      <pass-share-step
        :steps="steps"
        :passDetail="passDetail"
        :isToVerifyIdentity="isToVerifyIdentity"
        :isUserInvited="isUserInvited"
        :isRequestNeedsApproval="isRequestNeedsApproval"
        :isUserVerified="isUserVerified"
        :userProfile="loggedInUserDetail"
        :name="loggedInPerson"
        :reviewInquiryQuestion="reviewAgreementQuestion"
        :isReviewCompleted="reviewAgreementOk"
        :updateReviewFunc="updateIndiPassReviewAgreementOk"
        :shareDetailsInquiryQuestion="userDetailsQuestion"
        :updateShareDetailsFunc="updateShareDetailsIndividualPass"
        :activeStep="activeStep"
        :goToUrl="originUrl"
        :individualPass="individualPassDetail"
      />
    </section>
  </div>
</template>

<script>
import PassShareStep from './PassShareSteps'

export default {
  name: 'steps-view',
  components: {
    PassShareStep
  },
  props: {
    steps: Array,
    updateIndiPassReviewAgreementOk: Function,
    updateShareDetailsIndividualPass: Function,
    passDetail: Object,
    individualPassDetail: Object,
    loggedInUserDetail: Object,
    isToVerifyIdentity: {
      type: Boolean,
      default: false
    },
    isUserInvited: {
      type: Boolean,
      default: false
    },
    isRequestNeedsApproval: {
      type: Boolean,
      default: true
    },
    isUserVerified: {
      type: Boolean,
      default: false
    },
    userProfile: {
      type: String,
      default: ''
    },
    reviewAgreementQuestion: {
      type: String,
      default: ''
    },
    reviewAgreementOk: {
      type: Boolean,
      default: false
    },
    userDetailsQuestion: {
      type: String,
      default: ''
    },
    originUrl: {
      type: String,
      default: ''
    },
    passQuestion: {
      type: String,
      default: ''
    },
    loggedInPerson: {
      type: String,
      default: ''
    },
    activeStep: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/share/passes/StepsView.vue